import { appConfig } from "@env/app-config";
import { LocalStorageService } from "@core/storage/local-storage.service";
import { StorageProvider } from "@core/storage/storage.provider";
import { PageCacheKey } from "@modules/basic/page/page-object-tree";
import { Environment } from "@env/Environment";

let name = "qp-core-storage";

angular.module(name, [])
    .provider({
        storageService: StorageProvider
    })
    .config(["storageServiceProvider", function (storageProvider: StorageProvider<PageCacheKey>) {
        storageProvider.build(appConfig.appName, LocalStorageService);
    }])

export { name }
